/* WTF: free-shipping reassurance on the /cart page.
   Shipping is now free on every U.S. order, so this is a static
   affirmation (no threshold math). Reuses .wtf-ship-bar styles from
   layout/theme.liquid.
   2026-10-04: the cart drawer renders its own line in Liquid (snippets/cart-drawer.liquid, id WtfDrawerShipBar),
   because the drawer re-render wiped a bar inserted by script. The drawer branches were removed from this file.
   2026-10-14 (speed build 1, audit 15): sections/main-cart-items.liquid now prints the bar when the cart has items, so it is in the first paint and
   the cart lines no longer move. This script only keeps it right afterwards: it hides the bar when the cart becomes empty and puts it back (if it
   was missing) when items exist. No /cart.js request at load any more; the request after a cart change is debounced (150 ms). */
(function () {
  var BAR_ID = 'WtfShipBar';

  function buildBar() {
    var bar = document.createElement('div');
    bar.className = 'wtf-ship-bar';
    bar.id = BAR_ID;
    bar.innerHTML =
      '<p class="wtf-ship-bar__msg wtf-ship-bar__msg--unlocked" id="WtfShipBarMsg">Free U.S. Shipping · Est. delivery 2–5 days</p>';
    return bar;
  }

  function findAnchor() {
    var cartPageHeading = document.querySelector('.title-wrapper-with-link');
    if (cartPageHeading) {
      return { el: cartPageHeading, position: 'afterend' };
    }
    return null;
  }

  function ensureBarInserted() {
    var existing = document.getElementById(BAR_ID);
    if (existing) return existing;
    var anchor = findAnchor();
    if (!anchor) return null;
    var bar = buildBar();
    anchor.el.insertAdjacentElement(anchor.position, bar);
    return bar;
  }

  function updateShippingBar(cart) {
    if (!cart || cart.item_count === 0) {
      var existing = document.getElementById(BAR_ID);
      if (existing) existing.style.display = 'none';
      return;
    }
    var bar = ensureBarInserted();
    if (bar) bar.style.display = '';
  }

  function refreshFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(updateShippingBar)
      .catch(function () {});
  }

  function watchForCartChanges() {
    if (!window.MutationObserver) return;

    var cartItemsSection = document.getElementById('main-cart-items');
    if (cartItemsSection) {
      var timer = 0;
      new MutationObserver(function () {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          timer = 0;
          refreshFromServer();
        }, 150);
      }).observe(cartItemsSection, { childList: true, subtree: true });
    }
  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      /* R543 FIX 7 (2026-10-09): the bar attaches to the /cart page heading only. On every other page ensureBarInserted() finds no
         anchor and returns null, and refreshFromServer() then did nothing with its /cart.js answer. Stop before the request. */
      if (!findAnchor()) return;
      watchForCartChanges();
    },
    { once: true }
  );
})();
